export const RESET_FORGOT_PASSWORD = 'RESET_FORGOT_PASSWORD';
export default function resetForm() {
    return {
        type: RESET_FORGOT_PASSWORD,
    };
}
